




















































































































































































































































































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import FilterComponent from '@/components/FilterComponent.vue';
import { fetchProspectsPrescriber } from '@/utils/filters';
import TextEditor from '@/components/TextEditor.vue';
import {getCustomerPrescriber, getIsFile, getLotsPrescriber, postSendMailToProspectWithDocuments} from '@/api/api';
import MailToProspect from "@/models/MailToProspect";
import {isEmpty} from "lodash";
import Program from '@/models/Program';
import { getConnectedUser } from '@/api/api';
import User from '@/models/User';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { formatLotType, formatLotStatus } from '@/data/lot';

// @ts-ignore
import { quillEditor } from 'vue-quill-editor'
import { formatDocumentType, DOCUMENT_TYPE } from "@/data/documentTypes";
import { BACKEND_URL } from '@/helpers/constants';
import { buildDocumentUrl } from '@/helpers/document';


interface EmailItem {
  value: string;
  error: string | null;
  valid: boolean;
}

interface GroupedDocItem {
  doc: any;
  label: string;
  url: string;
  icon: string;
  colorClass: string;
}

interface DocumentGroup {
  type: string;
  label: string;
  items: GroupedDocItem[];
}

// Ordre d'affichage des catégories de documents du programme
const TYPE_ORDER: DOCUMENT_TYPE[] = [
  'documents_notice',
  'documents_notice_pro',
  'documents_booking_contract',
  'documents_floor_plan',
  'documents_parking_plan',
  'documents_works_contract',
  'documents_commercial_brochure',
  'documents_management_brochure',
  'documents_rental_agreement',
  'documents_annual_charge',
  'documents_general_assembly',
  'documents_autres',
];

const getBase64 = (file: File): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => reject(error);
  });
};

@Component({
  components: {
    FilterComponent,
    TextEditor,
    quillEditor

  },
  filters: {
    formatDocumentType,
    formatLotStatus,
    formatLotType
  },
})


export default class sendDocModal extends Vue {
  @Prop() program: Program | null = null;
  @Prop() programId: number | undefined;
  @Prop() openAction: boolean = true;



  files: File[] = [];
  fileError = '';
  isDragging = false;
  messageError = '';
  sending = false;
  maxFileSize = 25 * 1024 * 1024;


  emailList: EmailItem[] = [{ value: '', error: null, valid: false }];
  globalEmailError: string = '';

  get hasEmailErrors(): boolean {
    return this.emailList.some((email: EmailItem) => email.error);
  }

  get validEmailsCount(): number {
    return this.emailList.filter((email: EmailItem) => email.valid && email.value.trim()).length;
  }

  // Documents du programme regroupés par type, avec numérotation des doublons
  get groupedProgramDocuments(): DocumentGroup[] {
    const docs: any[] = (this.program && this.program.documents) || [];
    return TYPE_ORDER
      .map((type: DOCUMENT_TYPE) => {
        const typeDocs = docs.filter((d: any) => d.type === type);
        const typeName = formatDocumentType(type);
        const items: GroupedDocItem[] = typeDocs.map((doc: any, idx: number) => {
          const ext = doc.document ? doc.document.extension : '';
          return {
            doc,
            label: typeDocs.length > 1 ? `${typeName} ${idx + 1}` : typeName,
            url: this.getDocumentUrl(doc),
            icon: this.getBadgeIcon(ext),
            colorClass: this.getBadgeColorClass(ext),
          };
        });
        return { type, label: typeName, items };
      })
      .filter((group: DocumentGroup) => group.items.length > 0);
  }

  get displayedSecondaryImages(): any[] {
    return (this.program && this.program.images) ? this.program.images.slice(0, 5) : [];
  }

  get lotsWithPlan(): any[] {
    return this.lots
      .filter((lot: any) => lot && lot.plan && lot.status !== 'acted')
      .slice()
      .sort((a: any, b: any) => String(a.name).localeCompare(String(b.name), 'fr', { numeric: true }));
  }

  get totalSelectedCount(): number {
    return this.docSelect.length
      + this.docSelectLot.length
      + this.docSelectCompany.length
      + this.docImgMainSelect.length
      + this.docImgSecondSelect.length
      + this.files.length;
  }

  isGroupFullySelected(items: GroupedDocItem[]): boolean {
    return items.length > 0 && items.every((it: GroupedDocItem) => this.docSelect.includes(it.doc));
  }

  isGroupPartiallySelected(items: GroupedDocItem[]): boolean {
    return items.some((it: GroupedDocItem) => this.docSelect.includes(it.doc)) && !this.isGroupFullySelected(items);
  }

  toggleGroupSelection(items: GroupedDocItem[]): void {
    if (this.isGroupFullySelected(items)) {
      this.docSelect = this.docSelect.filter((d: any) => !items.some((it: GroupedDocItem) => it.doc === d));
    } else {
      const toAdd = items
        .filter((it: GroupedDocItem) => !this.docSelect.includes(it.doc))
        .map((it: GroupedDocItem) => it.doc);
      this.docSelect = [...this.docSelect, ...toAdd];
    }
  }



  prog: Program | null = null;
  lots: any[] = [];
  user: User | null = null;

  isNotSend: boolean = true;
  isLoadingData: boolean = true;


  isSend: boolean = false;
  docSelect: Array<any> = [];
  docSelectLot: Array<any> = [];
  docSelectCompany: Array<any> = [];
  docImgMainSelect: Array<any> = [];
  docImgSecondSelect: Array<any> = [];
  mailInfo: MailToProspect = {
    program_name: '',
    program_city: '',
    prospect_email: '',
    prescriber_email: '',
    prescriber_message: '',
    document_link: '',
    document_name: '',
    document_id: '',
    prescriber_id: 0,
    program_id: this.programId,
    prospect_id: 0,
    signature: true,
    personnal_files: [],
  }


  // option pour quillEditor
  quillOption = {
    placeholder: "Tapper votre signature ici...",
    modules: {
      toolbar: [
        'bold',
        'italic',
        'underline',
        { 'color': [] },
        { 'background': [] },
        'link',
        'image',
        {'size': ['small',false,'large','huge']},
      ]
    }
  }

  // recupere tout les prospects enregistrés
  get fetchProspectsPrescriber() {
    return fetchProspectsPrescriber;
  }

  getDocumentUrl(document: any): string {
    if (!document) return '';
    if (document.document) {
      return `${BACKEND_URL}${document.document.url}${document.document.name}.${document.document.extension}`;
    }
    if (document.plan) {
      return buildDocumentUrl(BACKEND_URL, document.plan);
    }
    if (document.image) {
      return `${BACKEND_URL}${document.image.url}${document.image.name}.${document.image.extension}`;
    }
    if (document.url && document.name && document.extension) {
      return `${BACKEND_URL}${document.url}${document.name}.${document.extension}`;
    }
    return '';
  }

  previewDocument(document: any) {
    try {
      const url = this.getDocumentUrl(document);
      if (url) {
        window.open(url, '_blank');
      } else {
        this.showError('Impossible d\'ouvrir ce document');
      }
    } catch (error) {
      console.error('Error in preview:', error);
      this.showError('Une erreur est survenue lors de l\'ouverture du document');
    }
  }

  getExtFromName(name: string): string {
    const parts = name.split('.');
    return parts.length > 1 ? parts.pop()!.toLowerCase() : '';
  }

  getBadgeIcon(ext: string): string {
    const e = (ext || '').toLowerCase();
    if (e === 'pdf') return 'fas fa-file-pdf';
    if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(e)) return 'fas fa-file-image';
    if (['doc', 'docx'].includes(e)) return 'fas fa-file-word';
    if (['xls', 'xlsx', 'csv'].includes(e)) return 'fas fa-file-excel';
    if (['ppt', 'pptx'].includes(e)) return 'fas fa-file-powerpoint';
    return 'fas fa-file-alt';
  }

  getBadgeColorClass(ext: string): string {
    const e = (ext || '').toLowerCase();
    if (e === 'pdf') return 'pdf';
    if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(e)) return 'image';
    if (['doc', 'docx'].includes(e)) return 'word';
    if (['xls', 'xlsx', 'csv'].includes(e)) return 'excel';
    if (['ppt', 'pptx'].includes(e)) return 'ppt';
    return 'default';
  }



  async is_file(id: any, type:string) {
    const { data } = await getIsFile(id, type);
    if(data) {
      return data;
    }
    return false;
  }



  showSuccess(message: string) {
    const $vs = (this as any).$vs;
    $vs.notify({
      color: 'success',
      position: 'top-right',
      title: 'Succès',
      text: message,
    });
  }

  showError(defaultMessage: string) {
    const $vs = (this as any).$vs;
    $vs.notify({
      color: 'danger',
      position: 'top-right',
      title: 'Erreur',
      text: defaultMessage,
    });
  }

  load() {
    const $vs = (this as any).$vs;
    $vs.loading()
  }

  unload() {
    const $vs = (this as any).$vs;
    $vs.loading.close()
  }




  async mounted() {
  this.isLoadingData = true;
  try {
    const dataUser = await getConnectedUser();
    this.user = dataUser.data;
    // on bind les valeur relatif à l'user pour l'envois de mail
    this.user.signature = this.user.signature == undefined ? '' : this.user.signature;
    this.mailInfo = {
      prescriber_message: '<br><br><br>',
      prescriber_email: this.user.email,
      program_name: '',
      program_city: '',
      prospect_email: '',
      document_link: '',
      document_name: '',
      document_id: '',
      prescriber_id: this.user.id,
      program_id: this.programId,
      prospect_id: 0,
      signature: true,
      personnal_files: []
    }
  } catch (e) {
    console.error("Erreur lors du chargement de l'utilisateur", e);
  }

  try {
    // recupere les lots
    // @ts-ignore
    let response = await getLotsPrescriber(this.programId);
    let lotsData = response.data && response.data.data ? response.data.data : response.data;
    let validLots: any[] = [];

    if (Array.isArray(lotsData)) {
      for (let i = 0; i < lotsData.length; i++) {
        try {
          let currentLot = lotsData[i];

          if (!currentLot || currentLot.status === 'sold') {
            continue;
          }

          if (currentLot.plan && currentLot.plan.id) {
            let file_exists = await this.is_file(currentLot.plan.id, 'plan');
            if (file_exists === true) {
              validLots.push(currentLot);
            }
          } else {
            validLots.push(currentLot);
          }
        } catch (lotError) {
          console.warn(`Erreur sur le lot à l'index ${i}, passage au suivant:`, lotError);
          continue;
        }
      }
    }
    this.lots = validLots;
  } catch (e) {
    console.error("Erreur globale lors de la récupération des lots", e);
    this.lots = [];
  }

  try {
    // retire tout les documents de type 'documents_global_plan'
    const documents = this.program && this.program.documents ? this.program.documents : [];
    let cleanDocuments: any[] = [];
    for (let i = 0; i < documents.length; i++) {
      try {
        if (documents[i] && documents[i].document && documents[i].document.id) {
          let file_exists = await this.is_file(documents[i].document.id, 'doc');
          if (documents[i].type != 'documents_global_plan' && file_exists) {
            cleanDocuments.push(documents[i]);
          }
        }
      } catch (docError) {
        console.warn("Erreur sur un document, passage au suivant:", docError);
        continue;
      }
    }
    if (this.program) this.program.documents = cleanDocuments;

    const images = this.program && this.program.images ? this.program.images : [];
    let cleanImages: any[] = [];
    for (let i = 0; i < images.length; i++) {
      try {
        if (images[i] && images[i].image && images[i].image.id) {
          let file_exists = await this.is_file(images[i].image.id, 'image');
          if (file_exists) {
            cleanImages.push(images[i]);
          }
        }
      } catch (imgError) {
        console.warn("Erreur sur une image, passage à la suivante:", imgError);
        continue;
      }
    }
    if (this.program) this.program.images = cleanImages;

    let cleanPrimary = undefined;
    const primary_perspective = this.program ? this.program.primary_perspective : null;
    if (primary_perspective && primary_perspective.id) {
      try {
        let file_exists = await this.is_file(primary_perspective.id, 'image');
        if (file_exists) {
          cleanPrimary = primary_perspective;
        }
      } catch (primError) {
        console.warn("Erreur sur l'image principale:", primError);
      }
    }
    //@ts-ignore
    if (this.program) this.program.primary_perspective = cleanPrimary;

  } catch (e) {
    console.error("Erreur lors du nettoyage des documents du programme", e);
  } finally {
    // Indique que le chargement est terminé, que ce soit un succès ou une erreur
    this.isLoadingData = false;
  }
}






//*********************************************************** */


triggerFileInput() {
     (this.$refs.fileInput as HTMLInputElement).click()
   }

   onDragOver() {
     this.isDragging = true
   }

   onDragLeave() {
     this.isDragging = false
   }

     onDrop(e: DragEvent) {
        e.preventDefault()
        this.isDragging = false
      var list = (e.dataTransfer && e.dataTransfer.files) as FileList
        for (var i = 0; i < list.length; i++) {
          this.onFile(list[i])
        }
      }

        onFileChange(e: Event) {
            var input = e.target as HTMLInputElement
            if (input.files) {
              for (var i = 0; i < input.files.length; i++) {
                this.onFile(input.files[i])
              }
            }
          }

          onFile(file: File) {
              if (file.size > this.maxFileSize) {
                this.fileError = file.name + ' is too big'
              } else {
                this.files.push(file)
                this.fileError = ''
              }
            }

            onDelete(i: number) {
              this.files.splice(i, 1)
            }

   openPreview(i: number) {
     const url = URL.createObjectURL(this.files[i])
     window.open(url, '_blank')
   }

   formatFileSize(bytes: number) {
     const mb = bytes / 1024 / 1024
     return mb.toFixed(2) + ' MB'
   }



    //********************************************************** */

    addEmail(): void {
    if (this.emailList.length < 10) {
      this.emailList.push({ value: '', error: null, valid: false });
    }
  }

  removeEmail(index: number): void {
    if (this.emailList.length > 1) {
      this.emailList.splice(index, 1);
      this.validateAllEmails();
    }
  }

  validateEmail(index: number): void {
    const email: EmailItem = this.emailList[index];
    const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email.value.trim()) {
      email.error = 'E-mail requis';
      email.valid = false;
    } else if (!emailRegex.test(email.value)) {
      email.error = 'Format d\'e-mail invalide';
      email.valid = false;
    } else if (this.isDuplicateEmail(email.value, index)) {
      email.error = 'E-mail déjà ajouté';
      email.valid = false;
    } else {
      email.error = null;
      email.valid = true;
    }

    this.updateGlobalEmailError();
  }

  isDuplicateEmail(emailValue: string, currentIndex: number): boolean {
    return this.emailList.some((email: EmailItem, index: number) =>
      index !== currentIndex && email.value.toLowerCase() === emailValue.toLowerCase()
    );
  }

  validateAllEmails(): void {
    this.emailList.forEach((_: EmailItem, index: number) => {
      this.validateEmail(index);
    });
  }

  updateGlobalEmailError(): void {
    if (this.hasEmailErrors) {
      this.globalEmailError = 'Veuillez corriger les erreurs dans les e-mails';
    } else if (this.emailList.every((email: EmailItem) => !email.value.trim())) {
      this.globalEmailError = 'Au moins un e-mail est requis';
    } else {
      this.globalEmailError = '';
    }
  }

  getValidEmails(): string[] {
    return this.emailList
      .filter((email: EmailItem) => email.valid && email.value.trim())
      .map((email: EmailItem) => email.value.trim());
  }

  resetEmails(): void {
    this.emailList = [{ value: '', error: null, valid: false }];
    this.globalEmailError = '';
  }





//*********************************************************** */


async onFilterProspect(prospectID: number): Promise<void> {
    try {
      const data = await getCustomerPrescriber(prospectID);
      // Clear existing emails and add the prospect's email
      this.emailList = [{ value: data.data.email, error: null, valid: true }];
      this.mailInfo.prospect_id = data.data.id;
      this.validateAllEmails();
    } catch (error) {
      console.error('Error fetching prospect:', error);
      this.showError('Erreur lors de la récupération du prospect');
    }
  }

  // 6. UPDATE your existing @Watch('openAction') method
  @Watch('openAction')
  onOpenAction(): void {
    if (this.openAction == true && this.isSend == true){
      this.isSend = false;
      this.isNotSend = true;
      this.docSelect = [];
      this.docSelectLot = [];
      this.docSelectCompany = [];
      this.docImgMainSelect = [];
      this.docImgSecondSelect = [];

      // Reset emails
      this.resetEmails();

      this.mailInfo = {
        prescriber_message: '<br><br><br>',
        // @ts-ignore
        prescriber_email: this.user ? this.user.email : '',
        program_name: '',
        program_city: '',
        prospect_email: '', // This will be replaced by emailList
        document_link: '',
        document_name: '',
        document_id: '',
        // @ts-ignore
        prescriber_id: this.user ? this.user.id : 0,
        // @ts-ignore
        program_id: this.programId,
        prospect_id: 0,
        signature : true,
        personnal_files: [],
      }
    }
  }

  // *********************************************************************************
async submitMail(): Promise<void> {
    this.load();

    try {
      // Validate all emails before submission
      this.validateAllEmails();

      const validEmails: string[] = this.getValidEmails();

      if (validEmails.length === 0) {
        this.showError('Veuillez ajouter au moins un e-mail valide');
        return;
      }

      if (this.hasEmailErrors) {
        this.showError('Veuillez corriger les erreurs dans les e-mails');
        return;
      }

      if (this.user != null && this.program != null){
        this.mailInfo.prescriber_id = this.user.id;
        this.mailInfo.program_id = this.program.id;
        this.mailInfo.program_name = this.program.name;
        this.mailInfo.program_city = this.program.address == undefined ? '' : this.program.address.city;

        // Initialize document fields as empty - controller expects this format
        this.mailInfo.document_id = '';
        this.mailInfo.document_link = '';
        this.mailInfo.document_name = '';

        // Build document links with safe URL construction and null checks
        for (const doc of this.docSelect) {
          if (doc && doc.document && doc.document.url && doc.document.name && doc.document.extension) {
            // Clean URL construction - remove double slashes
            const cleanUrl = this.cleanUrl(doc.document.url + doc.document.name + "." + doc.document.extension);
            this.mailInfo.document_link += cleanUrl + ";" ;
            this.mailInfo.document_name += (doc.type || 'Document') + ";";
            this.mailInfo.document_id += doc.id + ";";
          }
        }

        for (const doc of this.docSelectLot) {
          if (doc && doc.plan && doc.plan.url && doc.plan.file_name && doc.plan.extension && doc.name) {
            const cleanUrl = this.cleanUrl(buildDocumentUrl('', doc.plan));
            this.mailInfo.document_link += cleanUrl + ";" ;
            this.mailInfo.document_name += 'Plan du lot N°' + doc.name + ' - ' + formatLotStatus(doc.status) + ' - ' + formatLotType(doc.type) + ' - ' + (doc.floor || '') + ' - ' + (doc.surface_carrez || '') + ' - ' + (doc.price || '') + ";";
            this.mailInfo.document_id += (doc.plan.id || doc.id) + ";";
          }
        }

        for (const doc of this.docSelectCompany) {
          if (doc && doc.url && doc.name && doc.extension) {
            const cleanUrl = this.cleanUrl(doc.url + doc.name + "." + doc.extension);
            this.mailInfo.document_link += cleanUrl + ";" ;
            this.mailInfo.document_name += 'Plaquette de l\'entreprise' + ";";
            this.mailInfo.document_id += doc.id + ";";
          }
        }

        for (const doc of this.docImgMainSelect) {
          if (doc && doc.url && doc.name && doc.extension) {
            const cleanUrl = this.cleanUrl(doc.url + doc.name + "." + doc.extension);
            this.mailInfo.document_link += cleanUrl + ";" ;
            this.mailInfo.document_name += 'Image principale du programme' + ";";
            this.mailInfo.document_id += doc.id + ";";
          }
        }

        for (const doc of this.docImgSecondSelect) {
          if (doc && doc.image && doc.image.url && doc.image.name && doc.image.extension) {
            const cleanUrl = this.cleanUrl(doc.image.url + doc.image.name + "." + doc.image.extension);
            this.mailInfo.document_link += cleanUrl + ";" ;
            this.mailInfo.document_name += 'Image secondaire du programme' + ";";
            this.mailInfo.document_id += doc.image.id + ";";
          }
        }

        // Add personal files
        if (this.files.length) {
          this.mailInfo.personnal_files = await Promise.all(this.files.map(async (file: File) => {
            return {
              file_name: file.name,
              document: await getBase64(file)
            };
          }));
        }

        // Send email to each valid recipient individually
        if (!isEmpty(this.mailInfo.prescriber_message.trim())) {
          try {
            let successCount = 0;
            let errorCount = 0;
            const errors: string[] = [];

            for (const email of validEmails) {
              try {
                const individualMailData = {
                  ...this.mailInfo,
                  prospect_email: email
                };

                await postSendMailToProspectWithDocuments(individualMailData);
                successCount++;
              } catch (emailError) {
                errorCount++;
                errors.push(`${email}: ${emailError.message || 'Erreur inconnue'}`);
                console.error(`Error sending mail to ${email}:`, emailError);
              }
            }

            // Handle results
            if (successCount === validEmails.length) {
              this.isNotSend = false;
              this.isSend = true;
              this.files = [];
              this.resetEmails();
              this.showSuccess(`Mail envoyé avec succès à ${successCount} destinataire(s)`);
            } else if (successCount > 0) {
              this.files = [];
              this.resetEmails();
              this.showSuccess(`Mail envoyé à ${successCount} destinataire(s). ${errorCount} échec(s).`);
              if (errors.length > 0) {
                console.error('Detailed errors:', errors);
              }
            } else {
              this.showError(`Échec de l'envoi pour tous les destinataires. Veuillez vérifier les e-mails.`);
            }
          } catch(e) {
            console.error('Unexpected error during mail sending process:', e);
            this.showError('Une erreur inattendue est survenue lors de l\'envoi des documents');
          }
        } else {
          this.showError('Veuillez remplir le message');
        }
      } else {
        this.showError('Informations utilisateur ou programme manquantes');
      }
    } catch (error) {
      console.error('Unexpected error in submitMail:', error);
      this.showError('Une erreur inattendue s\'est produite');
    } finally {
      this.unload();
    }
  }

  // Helper method to clean URLs and prevent double slashes
  cleanUrl(url: string): string {
    // Remove multiple consecutive slashes but preserve protocol slashes (http://)
    // Also handle the specific case of /uploads/program//filename
    return url
      .replace(/([^:]\/)\/+/g, "$1")  // Remove double slashes except after protocol
      .replace(/\/uploads\/program\/\//, '/uploads/program/'); // Fix specific double slash issue
  }



}
